var React = require('react');

function MarsDouble (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M380.7 246l48.7-48.7-16.9-16.9a12 12 0 0 1 8.5-20.5h79a12.06 12.06 0 0 1 12 12.1v79a12 12 0 0 1-12.1 12 11.73 11.73 0 0 1-8.4-3.5l-16.9-16.9-48.7 48.7a144 144 0 1 1-265.1 91.8 174.49 174.49 0 0 0 63.3-18.4c-.1 1-.1 2.1-.1 3.2a80 80 0 1 0 80-80c-1 0-2.1.1-3.2.1a176.47 176.47 0 0 0 18.4-63.3 144.29 144.29 0 0 1 61.5 21.3z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M340 0h-79a12 12 0 0 0-8.5 20.5l16.9 16.9-48.7 48.7a143.94 143.94 0 1 0 45.2 45.2l48.7-48.7 16.9 16.9A12 12 0 0 0 352 91V12a12 12 0 0 0-12-12zM144 288a80 80 0 1 1 80-80 80.11 80.11 0 0 1-80 80z","className":"fa-primary","key":2})]);
}

MarsDouble.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = MarsDouble;

MarsDouble.default = MarsDouble;
